import React, { MutableRefObject } from 'react';
import { SwipeableHandlers } from 'react-swipeable';
import { Slide } from '@material-ui/core';
import { useSelector } from 'react-redux';

import { Player, Spinner } from '..';
import { Media } from '../../store/modules/media-viewer/types';
import { selectMediaViewer } from '../../store/modules/media-viewer/selectors';
import MediaPreviewStyles from './styles';

type Props = {
  media: Media;
  swipeable?: SwipeableHandlers;
  slideDirection: 'left' | 'right' | 'up' | 'down';
  isChangePreviewMedia: number | null;
  refPreviewContent: MutableRefObject<HTMLDivElement | null>;
};

const MediaAudio = ({
  media, swipeable, slideDirection, isChangePreviewMedia, refPreviewContent,
}: Props) => {
  const classes = MediaPreviewStyles();
  const { loading } = useSelector(selectMediaViewer);

  if (loading || !media.url) {
    return (
      <Slide
        direction={slideDirection}
        in={isChangePreviewMedia === null}
        mountOnEnter
        unmountOnExit
      >
        <div {...swipeable} className={classes.wrapper}>
          <Spinner />
        </div>
      </Slide>
    );
  }

  return (
    <Slide
      direction={slideDirection}
      in={isChangePreviewMedia === null}
      mountOnEnter
      unmountOnExit
      timeout={300}
    >
      <div style={{ height: '100%', width: '100%' }}>
        <Player src={media.url} media="audio" swipeable={swipeable} refPreviewContent={refPreviewContent} />
      </div>
    </Slide>
  );
};

export default MediaAudio;
